/**
 * "Visa annonser nära dig först?" — asked once, to a buyer whose area the page
 * does not know (P25009-425 BR-5, AC-3).
 *
 * A line above the results, never a modal: the list is already there and
 * stays usable whatever the answer. "Använd min plats" sorts by distance (the
 * browser asks for permission then, not before); "Inte nu" is remembered, and
 * so is a yes that found no position — the question is not asked again in
 * this browser (wheelplace.nearMePrompt, util/buyerArea.js).
 */
import React from 'react';
import { bool, func } from 'prop-types';

import css from './NearMePrompt.module.css';

const PinIcon = () => (
  <svg
    className={css.icon}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z" />
    <circle cx="12" cy="9.5" r="2.5" />
  </svg>
);

const NearMePrompt = ({ onAccept, onDismiss, busy }) => (
  <section className={css.root} aria-label="Visa annonser nära dig">
    <PinIcon />
    <div className={css.text}>
      <strong className={css.title}>Visa annonser nära dig först?</strong>
      <span className={css.detail}>
        Vi använder ditt ungefärliga område, aldrig din adress. Avstånden är ungefärliga.
      </span>
    </div>
    <div className={css.actions}>
      <button type="button" className={css.accept} onClick={onAccept} disabled={busy}>
        {busy ? 'Hämtar plats …' : 'Använd min plats'}
      </button>
      <button type="button" className={css.dismiss} onClick={onDismiss} disabled={busy}>
        Inte nu
      </button>
    </div>
  </section>
);

NearMePrompt.defaultProps = { busy: false };

NearMePrompt.propTypes = {
  onAccept: func.isRequired,
  onDismiss: func.isRequired,
  busy: bool,
};

export default NearMePrompt;
